import { FunctionComponent, ReactNode } from "react";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import * as Styled from "./styles";
import "react-circular-progressbar/dist/styles.css";

const defaultTrailColor = "#3B968B";
const disabledTrailColor = "#C3CAC9";

interface ProgressCircleProps {
  icon: ReactNode;
  progress: number;
  className?: string;
  name: string;
  color: "default" | "disabled";
}

const ProgressCircle: FunctionComponent<ProgressCircleProps> = ({
  icon,
  progress,
  className = "",
  name,
  color,
}: ProgressCircleProps) => {
  return (
    <Styled.CircleContainer className={className} data-name={name}>
      <CircularProgressbarWithChildren
        value={progress}
        circleRatio={1}
        strokeWidth={10}
        styles={{
          root: {},
          path: {
            stroke: `${color === "default" ? defaultTrailColor : disabledTrailColor}`,
            strokeLinecap: "round",
            transition: "stroke-dashoffset 0.5s ease 0s",
            transformOrigin: "center center",
          },
          trail: {
            stroke: `rgba(46, 45, 41, 0.1)`,
            strokeLinecap: "round",
            transformOrigin: "center center",
          },
          text: {},
        }}
      />
      <Styled.CircleIcon>{icon}</Styled.CircleIcon>
    </Styled.CircleContainer>
  );
};

export default ProgressCircle;
